import APPLICANT_DETAILS_DEFAULTS from "./steps/ApplicantDetails/defaultData";
import APPLICANT_EMPLOYMENT_DEFAULTS from "./steps/ApplicantEmployment/defaultData";
import EXPENDITURE_DEFAULTS from "./steps/Expenditure/defaultData";
import BROKER_DEFAULTS from "./steps/BrokerDetails/defaultData";
import LOAN_DEFAULTS from "./steps/Loan/defaultData";
import OTHER_DEFAULTS from "./steps/OtherDetails/defaultData";
import PROPERTY_DEFAULTS from "./steps/Property/defaultData";
import PRODUCT_DEFAULTS from "./steps/Product/defaultData";
import CONFIRM_DEFAULTS from "./steps/ReviewConfirm/defaultData";

export const DEFAULT_FORM_DATA = {
  ...BROKER_DEFAULTS,
  ...{
    numberOfApplicants: 1,
  },
  ...APPLICANT_DETAILS_DEFAULTS,
  ...APPLICANT_EMPLOYMENT_DEFAULTS,
  ...EXPENDITURE_DEFAULTS,
  ...LOAN_DEFAULTS,
  ...PROPERTY_DEFAULTS,
  ...OTHER_DEFAULTS,
  ...PRODUCT_DEFAULTS,
  ...CONFIRM_DEFAULTS,
};
